import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProtectedRoute from './ProtectedRoute';

/**
 * AdminRoute — wraps ProtectedRoute and additionally blocks SUB_USER role.
 * Sub-users who try to access /dashboard/* get redirected to /trade.
 */
export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  // Sub-users cannot access admin dashboard — send to trading portal
  if (user && user.role === 'SUB_USER') {
    return <Navigate to="/trade" replace />;
  }

  return <ProtectedRoute>{children}</ProtectedRoute>;
}
